<div class="select2">
    <div class="tc-form-field size-md">
        <label class="label">
            @if(!label){
            {{'GENERAL.CHOOSE' | translate}}
            }
            @if(label.length>0){
            {{label | translate}}
            }
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-select-option">
            <mat-select [disabled]="disable" [(ngModel)]="selectedValue" panelClass="panel-select-option-new">
                <mat-select-trigger *ngIf="selectedItem && hasIcon">
                    <img class="selected-icon" *ngIf="selectedItem && hasIcon" [src]='selectedItem.icon'>
                    <span class="selected-text" *ngIf=" selectedItem ">{{selectedItem.name}}</span>
                </mat-select-trigger>
                <ng-container class="select2-select-box ">
                    <mat-form-field *ngIf="haveSearch" appearance="outline " class="select2-search-input ">
                        <mat-label>{{'GENERAL.SEARCH' | translate}}</mat-label>
                        <input matInput (keyup)="search() " [(ngModel)]="searchValue "
                            placeholder="{{ 'GENERAL.SEARCH' | translate}} " autocomplete="off ">
                    </mat-form-field>
                    <mat-option *ngIf="haveAllOption " class="select2-option " [value]=" '' " (click)="emitEmpty() ">
                        {{'GENERAL.ALL' | translate}}
                    </mat-option>
                    <ng-container *ngFor="let item of searchedModel; let i=index; trackBy: trackByFn ">
                        <!-- <span class="select2-parent " *ngIf="item.children.length>0">{{item.name | translate}}</span> -->
                        <mat-option class="select2-option" [ngClass]="{'deactive': child.deactive}"
                            [disabled]="child.deactive" [value]="child.value" (click)="onSelect(child)"
                            *ngFor="let child of item.children">
                            <img *ngIf="hasIcon" [src]='child.icon'> {{child.name}}
                        </mat-option>
                    </ng-container>
                </ng-container>
            </mat-select>
            <!-- <mat-label *ngIf="isLoading">
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="25"></mat-spinner>
                </div>
            </mat-label> -->

        </mat-form-field>
    </div>
</div>